module.exports = __webpack_public_path__ + "img/user.ccbc6d1d.svg";